import React from 'react';
import '../assets/styles/components/Table.sass';

const TableIndividual = (props) => {
  const { racers } = props
  return(
    <div className="row">
      <div className="hidden-xs col-sm-12">
        <section className="table-results">
          <div className="table-results__title table-results__pos-category">CATEGORY POSITION</div>
          <div className="table-results__title table-results__pos-overall">GENERAL CLASSIFICATON</div>
          <div className="table-results__title table-results__category">CATEGORY</div>
          <div className="table-results__title table-results__number">RACE NUMBER</div>
          <div className="table-results__title table-results__racer">RACER NAME</div>
          <div className="table-results__title table-results__team">TEAM NAME</div>
          <div className="table-results__title table-results__time">OVERALL TIME</div>
          
          {racers.map( (racer, i) => (
            <>
              <div className="table-results__pos-category racer__red">-</div>
              <div className="table-results__pos-overall">-</div>
              <div className="table-results__category">{racer.categoria_en}</div>
              <div className="table-results__number">
                <p>{racer.numero}</p>
              </div>
              <div className="table-results__racer">
                <p><img src={`https://la-leyenda.com/2018/en/img/banderas/${racer.nacionalidad}.png`} alt=""/> {racer.nombre}</p>
              </div>
              <div className="table-results__team">{racer.equipo}</div>
              <div className="table-results__time">
                <p>{racer.tiempo}</p>
              </div>
            </>
          ))}
          
        </section>
        
      </div>
      <div className="visible-xs col-xs-12">
        <section className="table-results-mobile">
          {racers.map( (racer, i) => (
            <div className="table-results-mobile__item" key={i}>
              <p><b>Category classification:</b> -</p>
              <p><b>General classification:</b> -</p>
              <p><b>Category:</b> {racer.categoria_en}</p>
              <p><b>Team name:</b> {racer.equipo}</p>
              <p><b>Racer name:</b></p>
              <span className="table-results-mobile__item--racer">{racer.numero_corredor_1} <img src={`https://la-leyenda.com/2018/en/img/banderas/${racer.nacionalidad}.png`} alt=""/> {racer.nombre}</span>
              <p>
                <b>Overall time: </b> 
                {racer.tiempo}
              </p>
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}

export default TableIndividual;